import React, { useState } from "react";
import { useTranslation } from "react-i18next";

// Reusable Search Icon SVG
const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const HeaderSearchBar: React.FC = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  // Get the base shop page URL from our WordPress localized variables
  const shopPageUrl = window.themeVariables?.shopPageUrl || "/shop/";

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmedSearchTerm = searchTerm.trim();
    if (trimmedSearchTerm) {
      // Construct the URL with the standard WordPress search parameter 's'
      const searchUrl = new URL(shopPageUrl, window.location.origin);
      searchUrl.searchParams.set("s", trimmedSearchTerm);
      // Redirect the browser to the new URL
      window.location.href = searchUrl.toString();
    }
  };

  return (
    <form
      className="header-search-bar"
      onSubmit={handleSearchSubmit}
      role="search"
    >
      <input
        type="search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder={t("header.searchPlaceholder", "Search for products...")}
        className="header-search-bar__input"
        aria-label="Search for products"
      />
      <button
        type="submit"
        className="header-search-bar__button"
        aria-label="Submit search"
      >
        <SearchIcon />
      </button>
    </form>
  );
};

export default HeaderSearchBar;
